<template>
    <div>
        <div class="grid gap-8 grid-cols-1 | md:grid-cols-12 | xl:grid-cols-4">
            <div class="flex flex-col w-full | md:col-span-7 | xl:col-span-3">
                <template v-for="(field, i) in CalculatorController.getFieldsList()">
                    <component
                        :key="`component-field-${i}`"
                        :is="field.getComponentName()"
                        :field="field"
                        :showMinPrice="CalculatorController.showMinPrice()"
                        :fieldDisplayPrice="getFieldPrice(field)"
                        :selected="field.selectedOption"
                        :sizes="CalculatorController.getMirrorsSizeField()"
                        :isCircleSelected="CalculatorController.isCircleSelected()"
                        :disabled="CalculatorController.isFieldDisabled(field)"
                        :conditionController="ConditionController"
                        :fieldUpdated="update"
                    ></component>
                </template>
            </div>
            <div class="flex flex-col | md:col-span-5 | xl:col-span-1">
                <div class="sticky-pricing z-10">
                    <ProductPrice
                        :subtotal-price="CalculatorController.getSubtotalPrice()"
                        :tax="CalculatorController.getTaxValue()"
                        :tax-price="CalculatorController.getTaxPrice()"
                        :total-price="CalculatorController.getTotalPrice()"
                    />
                </div>

                <div class="flex flex-row py-4 align-center items-center z-0">
                    <div class="flex align-center items-center">
                        <label class="flex flex-1 pr-2 text-sm font-bold uppercase" for="quantity">
                            Quantity
                        </label>
                        <input
                            id="quantity"
                            class="bg-gray w-full shadow-sm appearance-none border text-center border-gray px-2 py-2 text-black focus:outline-none focus:bg-white focus:border-purple-500"
                            type="number"
                            v-model="quantity"
                        />
                    </div>
                    <div class="ml-2 flex-grow flex-shrink-0">
                        <button v-if="enableButton" @click="addToCart" class="btn btn--solid w-full">
                            {{ processingForm ? `ADDING TO BASKET...` : `ADD TO BASKET` }}
                        </button>
                        <button v-else disabled class="btn btn--disabled btn--p3 w-40 px-3 ">ADD TO BASKET</button>
                    </div>
                </div>

                <div v-if="validationMessage != null && !isErrorOnValidate" class="p-2 text-xs bg-gray z-0">
                    <p>{{ validationMessage }}</p>
                </div>

                <div v-if="validationMessage != null && !isErrorOnValidate" class="text-xs my-2 flex flex-wrap z-0">
                    <button class="btn btn--solid w-full">Continue Shopping</button>
                    <div class="flex items-center w-full my-2">
                        <span class="flex-1 flex h-px bg-gray-light"></span>
                        <span class="mx-2">or</span>
                        <span class="flex-1 flex h-px bg-gray-light"></span>
                    </div>
                    <a href="/basket" class="btn btn--transparent text-center w-full m-x-1">Go to Basket</a>
                </div>

                <div class="my-4 text-xs z-0">
                    <h3 class="font-bold mb-5">Delivery Notes</h3>
                    <p class="leading-5 text-justify">Our usual service is 7-10 working days from placing an order to
                        delivery.
                        Delivery is generally made by our own vans and drivers, but sometimes by couriers depending on
                        location, size and quantity.
                        All deliveries are curb-side deliveries.
                        If you are not at home or on site at the time of the delivery, our drivers are instructed to
                        find the safest place to leave the mirror. This is guaranteed until you see it.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormCalculatorController from "../_controllers/FormCalculatorController";
import VisibilityConditionController from "../_controllers/FieldConditions/VisibilityConditionController";
import ProductPrice from "./components/ProductPrice";
import ProductFields from "./components/fieldType/ProductField";
import MirrorSize from "./components/fieldType/MirrorSize";
import GlassSize from "./components/fieldType/GlassSize";
import Comment from "./components/fieldType/Comment";
import PriceCalculator from "../_controllers/PriceCalculator";
import ConditionPriceCalculator from "../_controllers/ConditionPriceCalculator";

const CalculatorController = new FormCalculatorController();
const ConditionController = new VisibilityConditionController(CalculatorController);
const ConPriceCalculator = new ConditionPriceCalculator();

export default {
    name: 'AdminFieldConfigurator',
    components: { MirrorSize, GlassSize, ProductFields, ProductPrice, Comment },
    props: {
        id: {},
        productFields: {},
        productSku: '',
        productName: '',
    },
    data() {
        return {
            CalculatorController: CalculatorController,
            ConditionController: ConditionController,
            ConPriceCalculator: ConPriceCalculator,
            validationMessage: null,
            isErrorOnValidate: false,
            processingForm: false,
            quantity: 1,
        }
    },
    watch: {
        quantity(newValue) {
            if (newValue === '') {
                return;
            }
            CalculatorController.setQuantity(Number(newValue))

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())
        }
    },
    mounted() {
        CalculatorController.setId(this.id)
        CalculatorController.setMirrorOrGlassSizeField()
        CalculatorController.setFieldsList(this.productFields)
    },
    computed: {
        enableButton() {
            return !!CalculatorController.allFieldsSelected();
        }
    },
    methods: {
        async addToCart() {
            this.processingForm = true;
            if (CalculatorController.productValid()) {
                await CalculatorController.addItemToCart();

                /**
                 * WooCommerce force refresh fragments
                 */
                $(document.body).trigger('wc_fragment_refresh');

                // TODO: add popup with configuration added product to cart
                this.validationMessage = 'Thank you for shopping, your product has been added to the cart.';
                this.isErrorOnValidate = false;

                this.triggerGaEvent();

                this.clearForm()
            } else {
                // TODO: add popup with errors
                const validationErrors = CalculatorController.getErrors();

                console.log(validationErrors)
            }
            this.processingForm = false
        },
        triggerGaEvent() {

            try {
                const trackObject = {
                    currency: "GBP",
                    value: this.CalculatorController.getTotalPrice(),
                    items: [
                        {
                            item_id: this.productSku,
                            item_name: this.productName,
                            price: this.CalculatorController.getTotalPrice(),
                            quantity: 1
                        }
                    ]
                }

                console.log(trackObject);

                gtag("event", "add_to_cart", trackObject);
            } catch (e) {

            }

        },
        getFieldPrice(field) {
            if (field.selectedOption) {
                const fieldPrice = ConPriceCalculator.getPriceFromSelectedOption(field.selectedOption)
                const priceCalculatorObj = new PriceCalculator(CalculatorController.getMirrorsSizeField())

                const priceFinal = priceCalculatorObj.getPriceBySize(fieldPrice, field.selectedOption.min_price, field.selectedOption.type);

                return PriceCalculator.roundUp(priceFinal, 2).toFixed(2);
            }

            return 0;
        },
        update() {
            CalculatorController.setMirrorOrGlassSizeField()
            CalculatorController.checkAllFieldVisibilityCondition()

            this.validate();

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())

        },
        validate() {
            CalculatorController.validate();
        },
        clearForm() {
            $(document.body).trigger('wc_fragment_refresh');

            ConPriceCalculator.setAllFields(this.CalculatorController.getSelectedFields())
            ConPriceCalculator.setSelectedFields(this.CalculatorController.getSelectedFields())

            CalculatorController.setFieldsList(this.productFields);
            CalculatorController.setMirrorOrGlassSizeField()
            CalculatorController.clearErrors()
        },
    }
}
</script>